import { ThermometerHighIcon } from './ThermometerHighIcon';

/**
 * author: Michael Richins
 * id DF51BF5D-831D-4FD1-8786-498CAC97DBB6
 * name thermometer-high
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-high.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const TemperatureHighIcon = ThermometerHighIcon;
export default TemperatureHighIcon